import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';

function ApriliaRs457() {
    window.scrollTo(0, 0);
    return (
        <div>
            <Helmet>

                <title>Aprilia 457’s Launch : Thousands of prebookings and billions of rupees of revenue.</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/aprilia-rs457-launch-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10"> <span class="spcase">APRILIA</span> RS457</p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block "> Aprilia 457’s Launch :  <br />  Thousands of prebookings and<br />   <span class="cuspn"> billions of rupees of revenue.</span> <br /></h4>
                                        <h4 className="d-block d-sm-none">  <br /> Aprilia 457’s Launch : <br />  Thousands of prebookings <br/> <span> and billions of rupees of revenue.</span></h4>
                                        
                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="6" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">

                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="p2   marbmdt  mbt20 ">
                                <span>Aprilia,</span> a leading name <span> in premium motorcycles,</span> launched the RS 457, targeting young riders seeking performance, style, and advanced technology. The challenge was to capture the attention of this niche audience and translate interest into thousands of pre-bookings.
                            </p>
                        </Col>

                        <Col lg={{ span: 6, order: 'last' }} sm={{ span: 6, order: 'last' }} xs={{ span: 12, order: 'first' }} className="offset-lg-1 pdr0 mbpdr15">
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/aprilia-rs457.png`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div className="box  problem padbxsb ">

                <Container fluid className="tpfold">
                    <Row>

                        <Col lg="8" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " style={{ marginBottom: '50px' }}> <span class="spcase">THE</span> <strong>Objectives</strong> </p>
                            <p className="">1. <strong>Successful Launch -</strong> Establish RS 457 as an anchor model as the first motorcycle launch, the success of which will pave the way for the other global models to make an entry in India.</p>
                            <p className="">2. <strong>Bookings -</strong> To plan and streamline production, Aprilia wanted clarity of future bookings hence wanted to close as many bookings in the pre-booking stage.</p>
                            <p className="">3. <strong>Brand Perception -</strong> To establish the perception of the Aprilia brand as a formidable option in the sports motorcycle category.</p>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="box  problem padbxsb ">

                <Container fluid className="tpfold">
                    <Row>
                        <Col lg="8" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " style={{ marginBottom: '50px' }}> <span class="spcase">THE</span> <strong>PROBLEM</strong> </p>
                            <p className="">1. <strong>Market Competition:</strong> The sports bike segment in India is highly competitive with other established players like Yamaha and Triumph launching their bikes around the same time as the RS 457.</p>
                            <p className="">2. <strong>Brand Perception:</strong> While Aprilia is a known brand, this was their first motorcycle launch in India, after years of selling only scooters in the country the brand had become synonymous with scooters and needed a racing motorcycling refresh.</p>
                            <p className="">3. <strong>Complex Buyer Journey:</strong> The decision-making process for purchasing a sports bike involves multiple touchpoints, including research, peer reviews, and test rides. Capturing and nurturing leads throughout this extended buyer journey posed a challenge, requiring sustained engagement efforts.</p>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* Process */}
            <div className="lgbox  problem padbxsb">

                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span><strong> PROCESS</strong> </p>
                            <h2 className="tcgold marbxst marbxsb padssmt">Market Analysis:</h2>
                            <p className="">1. <strong>Target Audience -</strong> A detailed target demographics, psychographics, and behaviors study was conducted.</p>
                            <p className="">2. <strong>Competitive Landscape -</strong> The closest competitors was entrenched but was grappling with branding issues around the kind of people riding its motorcycles whiles not follows and causing ruckus etc. handing a advantage to Aprilia. Other competitors were just dipping toes in the market and most of them had post-purchase issues.</p>
                            <p className="">3. <strong>Insight -</strong> Urban Indians of the top 10 Indian cities, primarily between 21-30, inclined towards MotoGP, with an EMI propensity of 8k a month were identified as a target audience.</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">Digital Strategy:</h2>
                            <Row>
                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <p className="">1. <strong>Channel Selection</strong></p>
                                </Col>
                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <ul style={{ listStyle: 'none' }}>
                                        <li>a. YouTube was used as entry in the category consideration as research happens on YouTube.</li>
                                        <li>b. Instagram to build lifestyle desire.</li>
                                        <li>c. Search to capture inmarket audience.</li>
                                        <li>d. Display remarketing to capture stragglers.</li>
                                    </ul>
                                </Col>

                            </Row>

                            <Row>
                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <p className="">2. <strong>Content strategy</strong></p>
                                </Col>

                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <ul style={{ listStyle: 'none' }}>
                                        <li>a. Led by adrenaline rush content.</li>
                                        <li>b. Aided by Influencer endorsement.</li>
                                        <li>c. Aided by publisher credibility.</li>
                                    </ul>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <p className="">3. <strong>Influencer and media strategy</strong></p>
                                </Col>
                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <ul style={{ listStyle: 'none' }}>
                                        <li>a. All top Moto publications were invited to Kari Race track in Coimbatore to experience the motorcycle.</li>
                                        <li>b. Reputed top motorcycle content creators were engaged.</li>
                                        <li>c. Avoid mainstream lifestyle creators to avoid dilution of racing seriousness.</li>
                                    </ul>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <p className="">4. <strong>Use of Aprilia Riders</strong></p>
                                </Col>
                                <Col lg="9" md="10" sm="10" xs="12" className='p-0'>
                                    <ul style={{ listStyle: 'none' }}>
                                        <li>a. Aprilia Moto GP were involved in the content strategy and media engagement to drive up the credibility of the 457.</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">Targeted Digital Advertising:</h2>
                            <Row>
                                <p className=""><strong>Audience Segmentation: </strong> We identified the core audience—young, tech-savvy bikers looking for premium sports bikes—and started targeting them utilizing demographic data, interest-based targeting, and behavioral insights.</p>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb">OSIDE:</h2>
                            <p className="mbt20 ">
                                With over 263 million motorcycle enthusiasts in India, not all have the capacity to own an Aprilia RS 457. To connect with those who do, we utilized our proprietary ad tool, OSIDE, to strategically refine the inventory and target High Net Worth Individuals (HNIs) who have <strong>both the interest and intent to purchase.</strong>
                            </p>
                        </Col>
                        <Col lg={{ span: 5, order: 'last' }} sm={{ span: 6, order: 'last' }} xs={{ span: 12, order: 'first' }} className="offset-lg-1">
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/oside.webp`} className="img-fluid text-right" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb">PLATFORM:</h2>
                            <p className="mbt20 ">
                                We executed targeted campaigns across Instagram, Facebook, Google Display Network, and YouTube. Additionally, we identified key websites and digital magazines popular among biking enthusiasts and motorcycling communities to boost awareness of the bike.
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb">CONTENT STRATEGY:</h2>
                            <p className="mbt20 ">
                                Created engaging ad creatives showcasing the RS 457's design, performance, and technological prowess. Leveraged video ads, carousel posts, and interactive formats to grab attention.
                            </p>
                        </Col>

                        <Col lg={{ span: 10, order: 'last' }} sm={{ span: 10, order: 'last' }} xs={{ span: 12, order: 'last' }} className="offset-lg-1">
                            <Row>
                                <Col lg="4" md="4" sm="6" xs="12" className="mbpt0 casebox mt-3">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/post1.webp`} className="img-fluid text-right" />
                                </Col>
                                <Col lg="4" md="4" sm="6" xs="12" className="mbpt0 casebox mt-3">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/post2.webp`} className="img-fluid text-right" />
                                </Col>
                                <Col lg="4" md="4" sm="6" xs="12" className="mbpt0 casebox mt-3">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/post3.webp`} className="img-fluid text-right" />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb">Driving Organic Traffic:</h2>
                            <p className="mbt20 ">
                                Initially, when users searched for the Aprilia RS 457 in India, the global Aprilia website dominated the search results. This was due to its earlier creation, higher domain rating (DR), and a greater number of backlinks.
                            </p>
                            <p className="mbt20 ">
                                To capture organic traffic and boost pre-booking numbers, it was essential to improve our rankings. We conducted a thorough SEO audit of the site and identified key areas for enhancement. Our strategy included enriching the content with relevant keywords, updating meta titles, and implementing schema markup.
                            </p>
                        </Col>
                    </Row>


                </Container>
            </div>
            {/* the impact */}
            <div className="lgbox  problem padbxsb">

                <Container fluid className="tpfold ">
                    <Row>

                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">

                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>IMPACT</strong> </p>

                            <Row className='mt-5'>
                                <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                    <p className="p2  mbt20 ">
                                        <strong>1. Followers increased by 200%+ & Website Traffic increased by 260%+.</strong>
                                    </p>
                                </Col>

                                <Col lg={{ span: 10, order: 'last' }} sm={{ span: 10, order: 'last' }} xs={{ span: 12, order: 'last' }} className="offset-lg-1">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/impact1.webp`} className="img-fluid text-right" />
                                </Col>
                                <Col lg={{ span: 10, order: 'last' }} sm={{ span: 10, order: 'last' }} xs={{ span: 12, order: 'last' }} className="offset-lg-1 mt-2">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/impact2.webp`} className="img-fluid text-right" />
                                </Col>
                            </Row>


                            <Row className='mt-5'>
                                <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                    <p className="p2  mbt20 ">
                                        <strong>2. Thousands of bookings and Billions of Rupees of revenue generated.</strong>
                                    </p>

                                </Col>
                            </Row>

                            <Row className='mt-5'>
                                <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                    <p className="p2  mbt20 ">
                                        <strong>3. Increase in traffic from premium users </strong>
                                    </p>
                                    <Row>
                                        <Col lg="8" md="6" sm="6" xs="12" className="mt-2">
                                            <p className="p2  mbt20 ">
                                                The majority of our traffic now comes from premium device users, particularly iPhones and Pixels. Previously, a significant portion of traffic originated from lower-priced phones, but after shifting our focus to premium audiences, we saw a remarkable increase in iPhone users visiting the website.
                                            </p>
                                        </Col>

                                        <Col lg="4" md="6" sm="6" xs="12" className="mt-2">
                                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/impact4.webp`} className="img-fluid text-right" />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={{ span: 10, order: 'last' }} sm={{ span: 10, order: 'last' }} xs={{ span: 12, order: 'last' }} className="mt-2 offset-lg-1">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/impact3.webp`} className="img-fluid text-right" />
                                </Col>
                            </Row>

                            <Row className='mt-5'>
                                <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                    <p className="p2  mbt20 ">
                                        <strong>4. Successfully outranked global website & market platforms</strong>
                                    </p>
                                </Col>

                                <Col lg={{ span: 10, order: 'last' }} sm={{ span: 10, order: 'last' }} xs={{ span: 12, order: 'last' }} className="offset-lg-1">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/impact5.webp`} className="img-fluid text-right" />
                                </Col>
                            </Row>
                            <Row className='mt-5'>
                                <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                    <p className="p2  mbt20 ">
                                        <strong>5. Website Traffic Increased by 260%+</strong>
                                    </p>
                                </Col>

                                <Col lg={{ span: 10, order: 'last' }} sm={{ span: 10, order: 'last' }} xs={{ span: 12, order: 'last' }} className="offset-lg-1">
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/aprilia/impact6.webp`} className="img-fluid text-right" />
                                </Col>
                            </Row>

                        </Col>
                    </Row>

                </Container>
            </div>

            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default ApriliaRs457;